export const checkFCMCompatibility = () => {
    const compatibility = {
      isCompatible: true,
      errors: [] as string[],
    };
  
    // Check if running in browser environment
    if (typeof window === 'undefined') {
      return {
        isCompatible: false,
        errors: ['Firebase Messaging is only available in browser environments'],
      };
    }
  
    // Check for Service Worker support
    if (!('serviceWorker' in navigator)) {
      compatibility.isCompatible = false;
      compatibility.errors.push('Service Workers are not supported in this browser');
    }
  
    // Check for Notification API support
    if (!('Notification' in window)) {
      compatibility.isCompatible = false;
      compatibility.errors.push('Notifications are not supported in this browser');
    }
  
    // Check for IndexedDB (used by Firebase)
    if (!window.indexedDB) {
      compatibility.isCompatible = false;
      compatibility.errors.push('IndexedDB is not supported in this browser');
    }
  
    return compatibility;
  };